import React, { useState } from "react";
import { CaretDown, Info } from "@phosphor-icons/react";
import { GLOSSARY } from "@/lib/laymen";

const ORDER = ["NDVI", "NDMI", "SoilMoisture", "ET0", "GDD", "YieldIndex", "ForestVitality"];

/** Collapsible "Was bedeutet das?" glossary for non-scientific users. */
export default function GlossaryPanel({ testid = "glossary-panel" }) {
  const [open, setOpen] = useState(false);
  const [expanded, setExpanded] = useState(null);

  return (
    <section className="eid-card" data-testid={testid}>
      <button
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-white/5 transition-colors rounded-sm"
        data-testid="glossary-toggle"
      >
        <div className="flex items-center gap-2">
          <span className="p-1.5 rounded-sm bg-[#00FA9A]/10 text-[#00FA9A]">
            <Info size={18} />
          </span>
          <div>
            <div className="eid-label">Klartext-Lexikon</div>
            <div className="text-base font-medium tracking-tight">
              Was bedeuten diese Werte für meinen Hof?
            </div>
          </div>
        </div>
        <CaretDown
          size={18}
          className="text-zinc-400 transition-transform"
          style={{ transform: open ? "rotate(180deg)" : "rotate(0)" }}
        />
      </button>

      {open && (
        <div className="px-5 pb-5 pt-1 border-t border-white/10" data-testid="glossary-content">
          <p className="text-sm text-zinc-400 mb-3">
            Klicke auf einen Begriff, um eine einfache Erklärung zu sehen – ohne Fachchinesisch.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
            {ORDER.map((k) => {
              const g = GLOSSARY[k];
              const isOpen = expanded === k;
              return (
                <div
                  key={k}
                  className="border border-white/10 rounded-sm bg-[#121212]"
                  data-testid={`glossary-item-${k}`}
                >
                  <button
                    onClick={() => setExpanded(isOpen ? null : k)}
                    className="w-full text-left px-3 py-2.5 flex items-center justify-between hover:bg-white/5 transition-colors"
                  >
                    <div>
                      <div className="font-mono text-sm font-medium text-white">{k}</div>
                      <div className="text-xs text-zinc-400">{g.short}</div>
                    </div>
                    <CaretDown
                      size={14}
                      className="text-zinc-500 transition-transform shrink-0"
                      style={{ transform: isOpen ? "rotate(180deg)" : "rotate(0)" }}
                    />
                  </button>
                  {isOpen && (
                    <div className="px-3 pb-3 text-sm text-white leading-relaxed space-y-1.5">
                      <p>{g.long}</p>
                      <div
                        className="inline-block text-[11px] font-mono px-2 py-1 rounded-sm bg-white/5 text-zinc-400"
                      >
                        Skala: {g.scale}
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </section>
  );
}
